import Session from '../auth/Session';

const AdminFunctions = {
    isAdminAsync: async function() {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/IsAdminAsync`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        // If token expired / logged out mid-flight
        if (response.status === 401 || response.status === 403) return false;

        if (!response.ok) {
            // helpful for debugging
            const text = await response.text().catch(() => "");
            throw new Error(`IsAdminAsync failed (${response.status}): ${text}`);
        }
        const data = await response.json();
        return data;
    },
    handleAdminUser: async function(isAdmin, adminFunction, nonAdminFunction) {
        if(isAdmin) {
            if(adminFunction){ adminFunction(); };            
        } else {
            if(nonAdminFunction){ nonAdminFunction(); };            
        }
    },    
    getRoleIdByName: async function(name) {        
        const token = Session.getToken();
        const response = await fetch(`api/Admin/GetRoleIdByNameAsync?roleName=${name}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        if (!response.ok) {
            // helpful for debugging
            const text = await response.text().catch(() => "");
            throw new Error(`getRoleIdByName failed (${response.status}): ${text}`);
        }
        const data = await response.json();
        return data.id;
    }
}

export default AdminFunctions;